export const INDEX = '/';
export const ESTATES = '/estate-planning';
export const PROBATE = '/probate';
export const TRUSTS = '/trusts';
export const BUSINESS = '/business';
export const ABOUT = '/about';
export const CONTACT = '/contact';
export const LEGAL = '/disclaimer';